/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import styles from './style.module.scss';
import { useStore } from '../../../../store/store';
import { ReactComponent as AppStoreSVG } from '../../../../assets/images/app-store.svg';
import { ReactComponent as GooglePlaySVG } from '../../../../assets/images/google-play.svg';
import { t } from '@web-solutions/module-localization';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import Button from 'src/onboarding/components/ui/button/Button';

const WebUpsaleFourth = () => {
  const email = useStore((state) => state.email);

  const handleNextStep = () => {
    window.open('https://onelink.to/4pqrsh', '_blank');
  };
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <Typography variant='h1-bold'>{t('onboarding.webUpsaleFourth.title')}</Typography>

        <div className={styles.description}>
          <Typography variant='body-semibold'>
            {t('onboarding.webUpsaleFourth.description1')}
          </Typography>
          <Typography variant='body-semibold'>
            {t('onboarding.webUpsaleFourth.description2')}
          </Typography>
        </div>

        {/* <a href='https://foodzee.onelink.me/WPdf/cjsolxg7' target='_blank'>
            <button onClick={handleNextStep}>
              <AppStoreSVG />
            </button>
          </a> */}
        {/* <a href='https://foodzee.onelink.me/WPdf/cjsolxg7' target='_blank'>
            <button onClick={handleNextStep}>
              <GooglePlaySVG />
            </button>
          </a>
        </div> */}
      </div>
      <Button title={t('onboarding.webUpsaleFourth.buttonTitle')} onClick={handleNextStep} />

      <Typography variant='caption-tabBar' className={styles.contact}>
        <a href='mailto:support@foodzee.tech' className={styles.emailLink}>
          {t('onboarding.webUpsaleFourth.login')} <b>support@foodzee.tech</b>
        </a>
      </Typography>
    </div>
  );
};

export default WebUpsaleFourth;
